export const fr = {
  releaseNotes: `
#### Nouvelle fonctionnalité : Questions de suivi cliquables

Profitez encore davantage de votre Assistant de flotte numérique, sans avoir à taper davantage.

Nous avons ajouté des questions de suivi cliquables qui apparaissent après chaque réponse. Ces suggestions vous permettent de poursuivre la conversation en un seul clic, sans avoir à saisir votre prochaine question.

##### Avantages
- **Accédez plus rapidement aux informations pertinentes**
- **Explorez facilement des sujets connexes**
- **Découvrez davantage d'insights et de recommandations**
- **Profitez d'une expérience de chat plus fluide et intuitive**

Cliquez simplement sur une question suggérée pour approfondir le sujet et maintenir la conversation.

**Moins de saisie. Des réponses plus rapides. De meilleures conversations. 🚀**
`,
  image: 'assets/images/release_notes_sample_fr.png',
  fixesAndImprovements: ``,
};
